import { Component, ElementRef, HostBinding, Inject, OnDestroy, Renderer2, ViewEncapsulation, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { Subscription } from 'rxjs/Subscription';
import { MatSnackBar, MatSnackBarConfig, throwMatDialogContentAlreadyAttachedError } from '@angular/material';
import { FuseConfigService } from '@fuse/services/config.service';
import { DataService } from '../services/data.service';
import { AclService } from 'ng2-acl/dist';

@Component({
    selector     : 'fuse-main',
    templateUrl  : './main.component.html',
    styleUrls    : ['./main.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FuseMainComponent implements OnDestroy, OnInit, AfterViewInit
{
    onConfigChanged: Subscription;
    fuseSettings: any;
    @HostBinding('attr.fuse-layout-mode') layoutMode;
    @ViewChild('chat') chat;

    public opendMenu = false;

    constructor(
        private _renderer: Renderer2,
        private _elementRef: ElementRef,
        private fuseConfig: FuseConfigService,
        private platform: Platform,
        public snackBar: MatSnackBar,
        private dataService: DataService,
        private aclService: AclService,

        @Inject(DOCUMENT) private document: any
    )
    {
        this.dataService.showAlert.subscribe((alert) => {
            if (alert.message) {
            this.snackBar.open(alert.message, '', {
                extraClasses: alert.type,
                duration: 5000,
                horizontalPosition: 'right',
                verticalPosition: 'top'
              });
            }
        });

        this.onConfigChanged =
            this.fuseConfig.onConfigChanged
                .subscribe(
                    (newSettings) => {
                        this.fuseSettings = newSettings;
                        this.layoutMode = this.fuseSettings.layout.mode;
                    }
                );

        if ( this.platform.ANDROID || this.platform.IOS )
        {
            this.document.body.className += ' is-mobile';
        }
    }

    ngOnInit() {}

    ngAfterViewInit() {

    }

    ngOnDestroy()
    {
        this.onConfigChanged.unsubscribe();
    }

    addClass(className: string)
    {
        this._renderer.addClass(this._elementRef.nativeElement, className);
    }

    removeClass(className: string)
    {
        this._renderer.removeClass(this._elementRef.nativeElement, className);
    }

    hasAccess(access) {
        return this.aclService.can(access);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts